import type { UnprocessedPayoutsColDefType } from "./types";

// eslint-disable-next-line import/prefer-default-export
export const unprocessedPayoutsColumns: readonly UnprocessedPayoutsColDefType[] =
  [
    {
      index: 1,
      id: "payoutId",
      label: "Payout ID",
    },
    {
      index: 2,
      id: "transferId",
      label: "Transfer ID",
    },
    {
      index: 3,
      id: "vendorId",
      label: "Vendor ID",
    },
    {
      index: 4,
      id: "amount",
      label: "Amount",
    },
    {
      index: 5,
      id: "createdAt",
      label: "Transfer Created",
    },
    {
      index: 6,
      id: "vendorName",
      label: "Vendor Name",
    },
  ];
